/**
 * Provide the singular form of the word and returns the count along singular or plural
 * form for it depending on the [count] arg
 *
 * @param singularWord
 * @param count
 * @returns
 */
function getNounCount(singularWord: string, count: number): string {
  let nounCount = `${count} `;
  if (count === 1) {
    nounCount += singularWord;
  } else {
    nounCount += `${singularWord}s`;
  }
  return nounCount;
}

export default getNounCount;
